import {
    CreateProps,
    EditProps,
    ListProps,
} from 'react-admin';
import Media from "./Utils/Media/Media";
const { MediaCreate, MediaEdit, MediaList } = Media;

export const VodList = (props: ListProps) => (
    <MediaList {...props} />
);

export const VodEdit = (props: EditProps) => (
    <MediaEdit {...props} />
);

export const VodCreate = (props: CreateProps) => (
    <MediaCreate {...props} />
);